module.exports = __webpack_public_path__ + "static/media/settings-access-bar.0e43271c.svg";